enum LoadState {
  Loading,
  Done,
  Error,
  UserError,
  NotFound,
}

export default LoadState;
